import { DialogService, GridAction } from '@eforall/dashboard';
import { AccTeamDialog, AccVentureDialog, PersonDialog } from '../../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccEntrepreneur } from '../acc-entrepreneurs-view.part';
import { SetClassSpeakerDialog } from '../set-class-speaker-dialog/set-class-speaker.dialog';

export function getActions(dialogService: DialogService, areaService: AcceleratorAreaService): GridAction<AccEntrepreneur>[] {

	const actions: GridAction<AccEntrepreneur>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Person Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Venture Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(AccVentureDialog, { data: { accVentureId: rows[0]!.accVentureId } }, 900, 700);
				await areaService.reloadData(); // TODO: optimize to reload only if changes were made
			}
		},
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'View Team Details',
			isEnabled: rows => !!rows.length && !!rows[0] && !!rows[0]!.accTeamId,
			execute: async rows => {
				await dialogService.showCustom(AccTeamDialog, { data: { accTeamId: rows[0]!.accTeamId } }, 900, 900);
				await areaService.reloadData(); // TODO: optimize to avoid full reload if no changes
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Set Class Speaker',
			isEnabled: rows => !!rows.length && areaService.canEdit(),
			execute: async rows => {
				const action = await dialogService.showCustom(SetClassSpeakerDialog, { data: { accEntrepreneurId: rows[0]!.accEntrepreneurId, isClassSpeaker: rows[0]!.isClassSpeaker } }, 400, 200);

				if (action.id === 'save') {
					const isClassSpeaker = action.callbackResult as boolean;
					await areaService.setClassSpeaker(rows[0]!.accEntrepreneurId, isClassSpeaker);
				}
			}
		},

	];

	return actions;
}